import axios from 'axios'
import { ContactAddressType } from '../../common/ContactAddress.type'

export const getContactAddress = async () => {
  const { data } = await axios.get<ContactAddressType[]>(
    `${process.env.REACT_APP_API_URL}/contactAddress`,
    {
      withCredentials: true,
    },
  )

  // console.log(`contactAddress.ts getContactAddress() contacts loaded. rows=${data.length}`)
  return data
}
